(() => {
  const TRIGGER_SELECTOR = '[data-product-watchdog-o2]';
  const DIALOG_SELECTOR = '[data-product-watchdog-dialog-o2]';
  const CLOSE_SELECTOR = '[data-product-watchdog-close-o2]';
  document.querySelectorAll(TRIGGER_SELECTOR).forEach((button) => {
    button.hidden = false;
  });
  if (window.__o2ProductWatchdogInitialized) return;
  window.__o2ProductWatchdogInitialized = true;

  let activeDialog;
  let activeButton;
  let previousOverflow;
  let previousPaddingRight;
  const restorePage = () => {
    removalObserver.disconnect();
    document.body.style.overflow = previousOverflow;
    document.body.style.paddingRight = previousPaddingRight;
    const button = activeButton;
    activeDialog = null;
    activeButton = null;
    if (button?.isConnected) button.focus();
  };
  // Removing an open native dialog does not emit close, for example during an editor render.
  const removalObserver = new MutationObserver(() => {
    if (activeDialog && !activeDialog.isConnected) restorePage();
  });

  document.addEventListener('click', (event) => {
    if (activeDialog?.open && (event.target === activeDialog || event.target.closest(CLOSE_SELECTOR))) {
      activeDialog.close();
      return;
    }
    const button = event.target.closest(TRIGGER_SELECTOR);
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
    event.preventDefault();
    // CMP also exposes showWebLayer on its stub before the SDK loads.
    if (window.exponea?.isLoaded === true && typeof window.exponea.showWebLayer === 'function') {
      window.exponea.showWebLayer('6aa7d54c5e2877454fb7425b');
      return;
    }

    const productInfo = button.closest('product-info') || button.form?.closest('product-info');
    const dialog = productInfo?.querySelector(DIALOG_SELECTOR) || document.querySelector(DIALOG_SELECTOR);
    if (!dialog || activeDialog?.open) return;
    activeDialog = dialog;
    activeButton = button;
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    previousOverflow = document.body.style.overflow;
    previousPaddingRight = document.body.style.paddingRight;
    dialog.showModal();
    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = `${parseFloat(getComputedStyle(document.body).paddingRight) + scrollbarWidth}px`;
    }
    document.body.style.overflow = 'hidden';
    removalObserver.observe(document.body, { childList: true, subtree: true });
    dialog.querySelector(CLOSE_SELECTOR).focus();
  });

  document.addEventListener(
    'close',
    (event) => {
      if (event.target !== activeDialog) return;
      restorePage();
    },
    true
  );
})();
